var _g, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTwitterX(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "default no-stroke",
    clipPath: "url(#clip0_1342_593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.847 10.469L21.132 2h-1.726L13.08 9.353 8.027 2H2.2l7.64 11.12L2.2 22h1.727l6.68-7.765L15.943 22h5.827l-7.924-11.531zm-2.365 2.748l-.774-1.107-6.16-8.81H7.2l4.971 7.11.774 1.107 6.462 9.242h-2.652l-5.273-7.541z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "alt"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.847 10.469L21.132 2h-1.726L13.08 9.353 8.027 2H2.2l7.64 11.12L2.2 22h1.727l6.68-7.765L15.943 22h5.827l-7.924-11.531zm-2.365 2.748l-.774 NaN"
  }))));
}
SvgTwitterX.displayName = 'TwitterX';
export default SvgTwitterX;